import { startCase } from "lodash-es";

export function enumToOptions(enumType: object): { label: string; value: object[keyof object] }[] {
  return Object.keys(enumType)
    .filter((key) => isNaN(Number(key)))
    .map((key) => ({
      label: key.replace(/([A-Z])/g, " $1").trim(),
      value: enumType[key as keyof object],
    }));
}

export function valueAsEnumKey(value: unknown, enumType: object, emptyPlaceholder = "-") {
  if (value && enumType) {
    const enumKey = Object.values(enumType).find((enumValue) => enumValue === value);
    if (enumKey) {
      return startCase(enumKey);
    }
  }
  return emptyPlaceholder;
}
